import { lazy, Suspense, type ReactNode } from 'react';
import { useLocation } from 'react-router';
import { ErrorBoundary } from '@good-season/ui';

import { isLiveScorebookPath } from './live-scorebook.js';

const HelpWidget = lazy(() => import('./HelpWidget.js'));
const AutoErrorNotice = lazy(() => import('./AutoErrorNotice.js'));

/**
 * Mounts the Help button on every screen except the live scorebook.
 *
 * The widget chunk is loaded only when this renders, so a game does not
 * download it and the first paint of the app does not include the forms.
 */
export function HelpMount(): ReactNode {
  const { pathname } = useLocation();
  if (isLiveScorebookPath(pathname)) return null;
  return (
    <ErrorBoundary surface="HP">
      <Suspense fallback={null}>
        <HelpWidget />
      </Suspense>
      <Suspense fallback={null}>
        <AutoErrorNotice />
      </Suspense>
    </ErrorBoundary>
  );
}
